<div class="main-form-box">
  <app-list-title title="הוספת אירוע" image="https://api.hanadiv.org/assets/Icons_Enterprise_Grey.svg"></app-list-title>
  <app-event-form></app-event-form>
</div>
